// extracted by mini-css-extract-plugin
module.exports = {"exponent_label":"exponentLabel_exponent_label__8jpae"};